import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import "@/assets/css/normalize.css";
import "@/assets/css/typography.css";
import "@/assets/css/style.css";
import "@/assets/css/component-style.css";
import "@/assets/css/vue-transitions.css";

Vue.prototype.$colorBackground = "#FFFFFF";
Vue.prototype.$colorPrimary = "#720793";

new Vue({
	created() {
		const queryString = window.location.search;
		Vue.prototype.$dataref = queryString.replace('?type=', '')
	},
	render: h => h(App)
}).$mount('#app')